import { LocalType } from '../models/localType';

export class SEOArguments {
    title: string;
    description: string;

    constructor(metadata: MetadataModel, currentLocale: keyof LocalType) {
        if (metadata.nodes?.[0]?.attributes) {
            const attributes = metadata.nodes?.[0]?.attributes;

            this.title = String(
                attributes?.meta_title?.values?.[0]?.[currentLocale]
            );
            this.description = String(
                attributes?.meta_description?.values?.[0]?.[currentLocale]
            );
        } else {
            this.title = '';
            this.description = '';
        }
    }
}
